import { useLocation, useNavigate } from "react-router-dom"
import { Popover, Stack, Typography } from "@mui/material"
import { ISidebarItem } from "."
import { IhandleOpenSubMenuPopover } from "./sidebar-menu"
import { SideBarMenuItemButton } from "./sidebar-menu"
import ROUTE_PATHS from "src/routes/route-path"

const SidebarSubmenuPopover = ({
  sidebarItem,
  anchorEl,
  onClose,
  handleOpenSubMenuPopover
}: {
  sidebarItem: ISidebarItem
  anchorEl: HTMLElement | null
  onClose: () => void
  handleOpenSubMenuPopover: ({ el, sidebarItem }: IhandleOpenSubMenuPopover) => void
}) => {
  const navigate = useNavigate()
  const location = useLocation()
  const isActive = (sidebarItem: ISidebarItem) => {
    if (!sidebarItem.href) return !!sidebarItem?.children?.some((e) => location.pathname.includes(e.href as string))
    const itemsSplit = sidebarItem.href?.split("/").filter(Boolean)
    if (itemsSplit?.length === 1) return location.pathname === ROUTE_PATHS.DASHBOARD
    else {
      return location.pathname.includes(sidebarItem.href)
    }
  }
  return (
    <Popover
      id="mouse-over-popover"
      sx={{ pointerEvents: "none" }}
      open={!!anchorEl}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: "center",
        horizontal: "right"
      }}
      transformOrigin={{
        vertical: "center",
        horizontal: "left"
      }}
      onClose={onClose}
      disableRestoreFocus
      slotProps={{
        paper: {
          onMouseEnter: () => handleOpenSubMenuPopover({ el: anchorEl, sidebarItem: sidebarItem as ISidebarItem }), // Keep popover open when hovering over it
          onMouseLeave: onClose, // Close when moving out
          sx: {
            "&.MuiPaper-root": { zIndex: 999, borderRadius: "6px", p: 1, width: "fit-content" },
            pointerEvents: "auto"
          }
        }
      }}
    >
      <Typography sx={{ p: 1, fontWeight: 600 }}>{sidebarItem?.title}</Typography>
      <Stack direction={"column"}>
        <>
          {sidebarItem?.children?.map((item) => (
            <SideBarMenuItemButton
              key={item.title}
              onClick={() => {
                navigate(item?.href as string)
                onClose()
              }}
              sx={{ px: 1, height: "30px", width: "auto" }}
              isSidebarOpen
              isActive={isActive(item)}
            >
              <>
                {item.icon}
                {item.title}
              </>
            </SideBarMenuItemButton>
          ))}
        </>
      </Stack>
    </Popover>
  )
}

export default SidebarSubmenuPopover
